export interface IPhoto {
  [id: string]: string;
}
export interface IPhotoUpload {
  [id: string]: File;
}

export interface IPhotoFile {
  [id: string]: string | File;
}

export interface IPhotoUrl {
  THUMBNAIL: string;
  THUMBNAIL_SQRT: string;
  FULL: string;
  FULL_SQRT: string;
}

export interface IEntryLicences {
  licenceUniqueId: string;
  licenceNumber: string;
}
export interface IEntryData {
  uniqueId: string;
  filename: string;
  position: number;
  createdDate: string;
  licences?: IEntryLicences[];
  presignedUrls?: IPhotoUrl;
}

export interface IGaleryValidationResult {
  warnings: string[];
}

export interface IGaleryData {
  uniqueId: string;
  entries: IEntryData[];
  version: number;
}

interface IGaleryEntryRequest {
  uniqueId: string;
  position: number;
  filename: string;
}
export interface IGaleryRequest {
  entryIdsForRemoval: string[];
  entryParameters: IGaleryEntryRequest[];
  version: number;
}

export interface IGaleryEntryFormValues {
  uniqueId: string;
  position: number;
  filename: string;
  createdDate?: string;
  licences?: IEntryLicences[];
}
export interface IGaleryFormValues {
  entryIdsForRemoval: string[];
  entryParameters: IGaleryEntryFormValues[];
}

export enum ESize {
  FULL = 'FULL',
  FULL_SQRT = 'FULL_SQRT',
  THUMBNAIL = 'THUMBNAIL',
  THUMBNAIL_SQRT = 'THUMBNAIL_SQRT',
}

export enum ESizeThumbnail {
  WIDTH = 270,
  HEIGHT = 312,
}
export enum ESizeModalThumbnail {
  WIDTH = (1 / 3) * ESizeThumbnail.WIDTH,
  HEIGHT = (1 / 3) * ESizeThumbnail.HEIGHT,
}
export enum ESizeThumbnailSQRT {
  WIDTH = 270,
  HEIGHT = 270,
}
export enum ESizeModalThumbnailSQRT {
  WIDTH = (1 / 3) * ESizeThumbnailSQRT.WIDTH,
  HEIGHT = (1 / 3) * ESizeThumbnailSQRT.HEIGHT,
}
